export default (waitingTime = 0) => {
    return new Promise((resolve) => {
        setTimeout(() => resolve(), waitingTime);
    });
};
